import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { FiltersSearchButton } from '../FiltersSearchButton';

const s = require('./search_filters.css');
const image = require('./dobroshrift.svg');

interface IProps {
  title: string;
  isDobroshrift: boolean;
  onSubmit(e: React.SyntheticEvent<HTMLElement>): void;
  onMapSubmit(e: React.SyntheticEvent<HTMLElement>): void;
  children: React.ReactNode;
}

export class SearchFilters extends React.Component<IProps> {
  public render() {
    return (
      <div className={s['c-filters-inner']}>
        <div {...mergeStyles(s['c-filters-title'], s['c-filters-title_dobroshrift'])}>
          {this.props.isDobroshrift ? (
            <div className={s['c-dobroshrift']}>
              <a
                className={s['c-dobroshrift-link']}
                href="https://dobroshrift.ru/"
                rel="noopener noreferrer"
                target="_blank"
              >
                #доброшрифт
              </a>
              <img src={image} title="Проверенное жильё находится на ЦИАН" />
            </div>
          ) : (
            <span className={s['c-filters-title-text']}>{this.props.title}</span>
          )}
        </div>
        <div className={s['c-filters-form']}>{this.props.children}</div>
        <div className={s['c-filters-form-buttons']}>
          <FiltersSearchButton dataMark="FiltersSearchButton" text="Найти" onClick={this.props.onSubmit} href="" />
          <FiltersSearchButton
            dataMark="FiltersSearchOnMapButton"
            text="Показать на карте"
            onClick={this.props.onMapSubmit}
            href=""
            isLight
          />
        </div>
      </div>
    );
  }
}
